import { v4 as uuidv4 } from 'uuid';

import { IKnmExpert248 } from '../../../APIPackage/KnmModule/interfaces/IKnmExpert248';
import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { createKnmExpertTypeSelectOption } from '../../../CorePackage/CatalogsModule/common/createKnmExpertTypeSelectOption';
import { IKnmErknmFormExpert } from '../interfaces/IKnmErknmFormExpert';

export const convertExpertsKnmDataToFormValues = (
  experts: IKnmExpert248[] | null | undefined,
): IKnmErknmForm['experts'] => {
  return experts?.map(item => ({
    ...item,
    title: item.title || undefined,
    type: item.type ? createKnmExpertTypeSelectOption(item.type) : undefined,
    listId: item.guid || uuidv4(),
  }));
};

export const convertExpertKnmDataToFormValues = (expert: IKnmExpert248): IKnmErknmFormExpert => {
  return {
    ...expert,
    title: expert.title || undefined,
    type: expert.type ? createKnmExpertTypeSelectOption(expert.type) : undefined,
    listId: expert.guid || uuidv4(),
  };
};
